import React from "react";
import { NavLink } from "react-router-dom";
import StrategicEvaluation from "../../images/events-img-1.png";
import BenchmarkingSolutions from "../../images/events-img-2.png";
import AssessmentSelection from "../../images/events-img-3.png";
import StrategySelectionSystems from "../../images/events-img-4.png";

function PrivacyPolicy() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      <div className="inner-banner">
        <div className="inner-banner-text">
          <h1>Privacy Policy</h1>
        </div>
      </div>

      <div className="inner-section-1-wrap">
        <div className="wrapper-1 text-left privacy-policy">
          <p>
            Privacy Policy for Techvest Global Solutions Inc.
            <br />
            Effective Date: April, 28, 2025
          </p>
          <p>
            Techvest Global Solutions Inc. ("Techvest," "we," "us," or "our") is
            committed to protecting the privacy of your information. This
            Privacy Policy outlines the types of information we may collect from
            you or that you may provide to us when you use our website,
            products, or services (collectively, our "Services"). It also
            describes our practices for collecting, using, maintaining,
            protecting, and disclosing that information.
          </p>
          <h3>1. Information We Collect</h3>
          <h6>
            We may collect several types of information from and about users of
            our Services, including:
          </h6>
          <p>
            <b>Personal Information:</b> This includes information that can be
            used to identify you, such as your name, email address, phone
            number, and any other information you provide to us voluntarily.
          </p>
          <p>
            <b>Non-Personal Information:</b> This includes information that does
            not directly identify you, such as your IP address, browser type,
            operating system, and information about your use of our Services.
          </p>
          <p>
            <b>Cookies and Similar Technologies:</b> We may use cookies, web
            beacons, and other similar technologies to collect information about
            your browsing activities and preferences.
          </p>
          <h3>2. How We Use Your Information</h3>
          <h6>
            We may use the information we collect for various purposes,
            including:
          </h6>
          <ul>
            <li>To provide and improve our Services.</li>
            <li>
              To communicate with you, including responding to your inquiries
              and providing customer support.
            </li>
            <li>
              To personalize your experience and deliver content and
              advertisements that are relevant to your interests.
            </li>
            <li>To analyze trends and gather statistical information.</li>
            <li>
              To detect, prevent, and address technical issues, security
              breaches, or fraud.
            </li>
            <li>To comply with any legal obligations.</li>
          </ul>
          <h3>3. How We Share Your Information</h3>
          <h6>
            We may share your information with third parties in the following
            circumstances:
          </h6>
          <p>
            <b>Service Providers:</b> We may share your information with
            third-party service providers who assist us in providing and
            maintaining our Services.
          </p>
          <p>
            <b>Business Partners:</b> We may share your information with our
            business partners to offer you certain products or services.
          </p>
          <p>
            <b>Legal Requirements:</b> We may disclose your information if
            required to do so by law or in response to a valid legal request.
          </p>
          <p>
            <b>Business Transfers:</b> If we are involved in a merger,
            acquisition, or sale of all or a portion of our assets, your
            information may be transferred as part of that transaction.
          </p>
          <p>
            <b>With Your Consent:</b> We may share your information with third
            parties with your consent.
          </p>
          <h3>4. Your Choices</h3>
          <h6>You have certain choices regarding your information:</h6>
          <p>
            <b>Access and Correction:</b> You may access and update your
            personal information by contacting us.
          </p>
          <p>
            <b>Opt-Out:</b> You may opt out of receiving promotional emails from
            us by following the instructions in those emails.
          </p>
          <p>
            <b>Cookies:</b> You can control cookies through your browser
            settings. However, disabling cookies may affect your ability to use
            certain features of our Services.
          </p>
          <h3>5. Data Security</h3>
          <p>
            We have implemented reasonable measures to protect your information
            from unauthorized access, use, and disclosure. However, no data
            transmission over the internet or electronic storage is completely
            secure, so we cannot guarantee absolute security.
          </p>
          <h3>6. International Data Transfers</h3>
          <p>
            Your information may be transferred to and maintained on servers
            located outside of your country or other governmental jurisdiction,
            where the data protection laws may differ from those in your
            jurisdiction.
          </p>
          <h3>7. Children's Privacy</h3>
          <p>
            Our Services are not intended for children under the age of 18, and
            we do not knowingly collect personal information from children under
            that age. If you believe that we have collected personal information
            from a child under 18, please contact us immediately.
          </p>
          <h3>8. Changes to This Privacy Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any material changes by posting the new Privacy Policy on our
            website.
          </p>
          <h3>9. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p>
            Techvest Global Solutions Inc.
            <br />
            Street W, Suite # 2500 Toronto, Ontario, M5G 1Z3 Canada
            <br />
            techvestgtm@techvestglobal.com
            <br />
            +1 6475354940
          </p>

          <h3>10. Disclaimer</h3>
          <p>
            No mobile information will be shared with third parties/affiliates
            for marketing/promotional purposes. All the above categories exclude
            text messaging originator opt-in data and consent. This information
            will not be shared with any third parties.
          </p>
        </div>
      </div>
      <div className="wrapper-1">
        <div className="line-3"></div>
      </div>

      <div className="inner-section-1-wrap">
        <div className="wrapper-1">
          <div className="wrap-1">
            <h2>
              Know what you need?
              <br />
              Submit your
              <span className="black-color"> Request</span> for information
              <span className="blue-color"> Here.</span>
            </h2>
            <a href="#" className="button-3">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
